import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';

import { CheckIcon, CancelIcon, CloseIcon } from './Styles/Icons';
import { Table, TableContainer, TableHeader, TableHeaderRow, TableHeaderColumn, TableBody, TableRow, TableColumn, Dialog, DialogTitle, DialogContent,
	FlexRow, FlexColumn, NotFound, InputGroup, TextField, Button, ButtonGroup, CircularButton } from './Styles/DSOSettingsDialogBox';

import { updateDSOConfig } from '../../actions/dsoActions';
import { formatCurrency, stripCurrency } from '../../commons/utils';
import { Theme } from '../Styles';

const paymentMethods = {
	bill_to_account: { name: 'Bill to Account', active: true, limit: true },
	credit_card: { name: 'Credit Card', active: false, limit: false },
};

const DSOSettingsDialogBox = ({ title = '', open = false, id = '', onClose = null, dso, supplier, ...props }) => {
	const [error, setError] = useState('');
	const [editMode, setEditMode] = useState(false);
	const [data, setData] = useState({});
	const [value, setValue] = useState(0);

	const onTrueHandler = (type, field, value) => {
		if (type === 'limit') {
			value = stripCurrency(value);
			if (value === 0 || value === '' || value === null || isNaN(value)) {
				setError('Limit cannot be empty.');
				Object.keys(dso).forEach((key, index) => {
					let item = dso[key];
					if (item._id === id) {
						if (item.supplier_config && item.supplier_config[supplier] && item.supplier_config[supplier].payment_methods) setData(item.supplier_config[supplier].payment_methods);
						else setData({});
					}
				});
			} else {
				updateDSOConfig({ [field]: value });
				setEditMode(false);
			}
		} else if (type === 'status') {
			updateDSOConfig({ [field]: value });
		}
	};

	const updateDSOConfig = (data) => {
		props.updateDSOConfig(id, data);
	};

	useEffect(() => {
		setEditMode(false);
		setError('');
		Object.keys(dso).forEach((key, index) => {
			let item = dso[key];
			if (item._id === id) {
				if (item.supplier_config && item.supplier_config[supplier] && item.supplier_config[supplier].payment_methods) setData(item.supplier_config[supplier].payment_methods);
				else setData({});
			}
		});
	}, [open, id, dso, supplier]);

	return (
		<Dialog
			maxWidth='md'
			fullWidth
			open={open}
			onClose={() => onClose()}
		>
			<DialogTitle>
            	{`${title} Settings`}
				<ButtonGroup alignRight alignTop>
					<CircularButton
						error
						outline
						onClick={() => onClose()}
					>
						<CloseIcon />
					</CircularButton>
				</ButtonGroup>
			</DialogTitle>

			<DialogContent style={{ padding: '0px' }}>
				<TableContainer
					height='auto'
					width='540px'
				>
					<Table>
						<TableHeader>
							<TableHeaderRow>
								<TableHeaderColumn style={{ width: '40%' }}>Payment Type</TableHeaderColumn>

								<TableHeaderColumn style={{ width: '30%' }}>Set Limit</TableHeaderColumn>

								<TableHeaderColumn
									alignRight
									style={{ flex: 1 }}
								>
									Actions
								</TableHeaderColumn>
							</TableHeaderRow>
						</TableHeader>

						<TableBody>
							{paymentMethods && Object.keys(paymentMethods).length ? (
								Object.keys(paymentMethods).map((method, index) => (
									<TableRow key={index}>
										<TableColumn>
											<FlexRow>
												<FlexColumn>{data[method] && data[method].is_active ? <CheckIcon /> : <CancelIcon />}</FlexColumn>

												<FlexColumn>
													<FlexRow>{paymentMethods[method].name}</FlexRow>

													<FlexRow style={{ fontSize: '12px', fontWeight: '400', lineHeight: '24px' }}>
														{data[method] && data[method].is_active ? (
															<span style={{ color: Theme.success }}>Currently Active</span>
														) : (
															<span style={{ color: Theme.error }}>Inactive</span>
														)}
													</FlexRow>
												</FlexColumn>
											</FlexRow>
										</TableColumn>

										<TableColumn>
											{paymentMethods[method].limit ? (
												editMode === true ? (
													<InputGroup
														markRequired={true}
														error={error}
													>
														<TextField
															name={'credit_limit'}
															disabled={false}
															autoFocus={true}
															placeholder='$0.00'
															value={value}
															onChange={(e) => {
																setValue(formatCurrency(e.target.value));
															}}
															error={error}
														/>
													</InputGroup>
												) : (
													<>{data[method] && data[method].limit ? formatCurrency(data[method].limit, true) : formatCurrency('0', true)}</>
												)
											) : (
												'-'
											)}
										</TableColumn>

										<TableColumn alignRight>
											{editMode === true ? (
												<ButtonGroup>
													<Button
														secondary
														outline
														fit
														onClick={() => {
															setEditMode(false);
														}}
													>
														Cancel
													</Button>

													<Button
														secondary
														fit
														onClick={() => {
															onTrueHandler('limit', `${method}_limit`, value);
														}}
													>
														Save
													</Button>
												</ButtonGroup>
											) : (
												<ButtonGroup>
													<Button
														secondary
														fit
														onClick={() => {
															setValue(data[method] && data[method].limit ? formatCurrency(data[method].limit) : formatCurrency('0'));
															setEditMode(true);
														}}
													>
														Edit
													</Button>

													{data[method] && data[method].is_active ? (
														<Button
															error
															fit
															onClick={() => {
																onTrueHandler('status', `${method}_is_active`, false);
															}}
														>
															Deactivate
														</Button>
													) : (
														<Button
															primary
															fit
															onClick={() => {
																onTrueHandler('status', `${method}_is_active`, true);
															}}
														>
															Activate
														</Button>
													)}
												</ButtonGroup>
											)}
										</TableColumn>
									</TableRow>
								))
							) : (
								<TableRow key='not-found'>
									<TableColumn colSpan={'100%'}>
										<NotFound line1="Couldn't find any items." />
									</TableColumn>
								</TableRow>
							)}
						</TableBody>
					</Table>
				</TableContainer>
			</DialogContent>
		</Dialog>
	);
};

const mapStatesToProps = (state) => {
	return {
		supplier: state.supplier.supplier,
	};
};

const mapFunctionsToProps = {
	updateDSOConfig,
};

export default connect(mapStatesToProps, mapFunctionsToProps)(DSOSettingsDialogBox);
